import * as Dropzone from "./Dropzone.styled";
export default Dropzone;
